<template>
  <Dropdown v-bind="$attrs" :class="{ show: show }" class="column-options">
    <template #button-content>
      <span class="column-options--label">{{ labelIcon }}</span>
      <Icon icon="gear" class="column-options--icon" />
    </template>
    <div class="column-options--dropdown">
      <SearchInput
        v-model="searchString"
        :placeholder="searchInputPlaceHolder"
        class="column-options--search"
      />
      <span
        class="clear-columns cl-blue-primary card-text-small"
        @click="clearCheckbox"
      >
        Limpar seleções
      </span>
      <slot>
        <InputCheckbox
          v-for="column in filterConfigOptions"
          :value="value"
          :inputValue="column"
          :key="column.name"
          :label="column.alias"
          :checked="isChecked(column.name)"
          class="column-options--checkbox"
          @input="$emit('input', $event)"
        />
      </slot>
    </div>
  </Dropdown>
</template>

<script>
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import Dropdown from '@solucoes/components-lib-tmp/src/components/patterns/Dropdown'
import InputCheckbox from '@solucoes/components-lib-tmp/src/components/elements/InputCheckbox'

export default {
  name: 'PmwConfigDropDown',
  components: {
    Icon,
    SearchInput,
    Dropdown,
    InputCheckbox
  },
  props: {
    searchInputPlaceHolder: {
      type: String,
      default: ''
    },

    configOptions: {
      type: Array,
      default: () => []
    },

    value: {
      type: Array,
      default: () => []
    },
    /** Traz o dropdown aberto ao adicionar o componente na página */
    showDropdownOnCreate: {
      type: Boolean,
      default: false
    },
    labelIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      show: false /** Filtro inicial não exibido pela falta de tabela */,
      searchString: ''
    }
  },
  computed: {
    /** Adiciona dentro do array configOptions os checkbox pesquisados no input search */
    filterConfigOptions() {
      return this.configOptions.filter(
        (data) =>
          data.alias.toLowerCase().indexOf(this.searchString.toLowerCase()) > -1
      )
    }
  },
  mounted() {
    if (this.showDropdownOnCreate) {
      this.showOptions()
    }
  },
  methods: {
    /** Limpa o array de checkboxes selecionadas */
    clearCheckbox() {
      this.$emit('input', [])
    },
    /**
     * Valida se o item.Name é igual a coluna exibida
     * @param {String} columnName - Nome da Coluna exibida no checkbox
     * para exibir checkbox marcados de colunas que estão sendo exibidas
     */
    isChecked(columnName) {
      if (!this.value.length) return false
      return this.value.findIndex((item) => item.name === columnName) > -1
    }
  }
}
</script>

<style lang="scss" scoped>
.column-options {
  float: right;
  margin-bottom: 10px;
  color: pmw-colors(blue-100);
  &--dropdown {
    display: flex;
    flex-direction: column;
    height: 288px;
    overflow-y: auto;
    padding-left: 14px;
    width: 210px;
    color: pmw-colors(grey-90);
  }

  &--search {
    width: 178px;
  }

  &--checkbox {
    padding-top: 21px;
  }
  &--label {
    font-size: font-size('size-medium');
    margin-right: 5px;
  }
  &:hover {
    color: pmw-colors(blue-80);
  }
}
.filter-new-columns {
  &:hover {
    cursor: pointer;
  }

  &--icon {
    width: 24px;
    height: 24px;
  }
}

.clear-columns {
  font-size: font-size('size-medium');
  margin-top: 10px;
  cursor: pointer;
}

.clear-columns:hover {
  color: pmw-colors(blue-100);
}

.show {
  color: $pmw-cyan;
}
</style>
